import { addFilter } from '@wordpress/hooks'
import { useSelect, dispatch } from '@wordpress/data'
import { PanelRow, TextControl, ToggleControl } from '@wordpress/components'
import { __ } from '@wordpress/i18n'

/**
 * Adding Stripe Content
 */
addFilter( 'wp_travel_payment_gateway_fields_stripe', 'wp-travel', (content) => {
    return [ ...content, <StripeContent /> ]
});

const StripeContent = () => {

    /**
     * Get Store Settings.
     */
    const { updateSettings } = dispatch('WPTravel/Admin');

    const allData = useSelect( (select) => {
        return select('WPTravel/Admin').getAllStore()
    }, [] );

    const {
        payment_option_stripe,
        stripe_new_payment_ui,
        stripe_publishable_key,
        stripe_secret_key,
        stripe_test_publishable_key,
        stripe_test_secret_key,
        stripe_enable_3d_secure,
        wt_test_mode
    } = allData

    return (
        <>
            {
                wt_test_mode === 'yes' ?
                <strong><p className="howTo" style={{color: '#ffffff', textAlign: 'center', backgroundColor: 'darkseagreen'}} >{ __( 'Test Mode Active', 'wp-travel-pro' ) }</p></strong>
                : <strong><p className="howTo" style={{color: '#ffffff', textAlign: 'center', backgroundColor: 'darkseagreen'}} >{ __( 'Live Mode Active', 'wp-travel-pro' ) }</p></strong>
            }
            <PanelRow>
                <label>{ _wp_travel.setting_strings.payment.enable_stripe }</label>
                <div className="wp-travel-field-value">
                    <ToggleControl
                        checked={ payment_option_stripe == 'yes' }
                        onChange={ () => {
                            updateSettings({
                                ...allData,
                                payment_option_stripe: 'yes' == payment_option_stripe ? 'no': 'yes'
                            })
                        } }
                    />
                    <p className="description">{ _wp_travel.setting_strings.payment.enable_stripe_note }</p>
                </div>
            </PanelRow>
            <PanelRow>
                <label>Enable New Payment UI</label>
                <div className="wp-travel-field-value">
                    <ToggleControl
                        checked={ stripe_new_payment_ui == 'yes' }
                        onChange={ () => {
                            updateSettings({
                                ...allData,
                                stripe_new_payment_ui: 'yes' == stripe_new_payment_ui ? 'no': 'yes'
                            })
                        } }
                    />
                    <p className="description">By Enabling this options new ui of stripe will be active on checkout page.</p>
                </div>
            </PanelRow>

            {
                payment_option_stripe === 'yes' &&
                <>
                    <PanelRow>
                        <label>{ _wp_travel.setting_strings.payment.stripe_checkout_test_publishable_key }</label>
                            <div className="wp-travel-field-value">
                                <TextControl
                                    value={ 'undefined' !== typeof stripe_test_publishable_key ? stripe_test_publishable_key : '' }
                                    onChange={
                                        (value) => {
                                            updateSettings({
                                                ...allData,
                                                stripe_test_publishable_key: value
                                            })
                                        }
                                    }
                                />
                            </div>
                    </PanelRow>

                    <PanelRow>
                        <label>{ _wp_travel.setting_strings.payment.stripe_checkout_test_secret_key }</label>
                            <div className="wp-travel-field-value">
                                <TextControl
                                    value={ 'undefined' !== typeof stripe_test_secret_key ? stripe_test_secret_key : '' }
                                    onChange={
                                        (value) => {
                                            updateSettings({
                                                ...allData,
                                                stripe_test_secret_key: value
                                            })
                                        }
                                    }
                                />
                            </div>
                    </PanelRow>

                    <PanelRow>
                        <label>{ _wp_travel.setting_strings.payment.stripe_checkout_live_publishable_key }</label>
                            <div className="wp-travel-field-value">
                                <TextControl
                                    value={ 'undefined' !== typeof stripe_publishable_key ? stripe_publishable_key : '' }
                                    onChange={
                                        (value) => {
                                            updateSettings({
                                                ...allData,
                                                stripe_publishable_key: value
                                            })
                                        }
                                    }
                                />
                            </div>
                    </PanelRow>

                    <PanelRow>
                        <label>{ _wp_travel.setting_strings.payment.stripe_checkout_live_secret_key }</label>
                            <div className="wp-travel-field-value">
                                <TextControl
                                    value={ 'undefined' !== typeof stripe_secret_key ? stripe_secret_key : '' }
                                    onChange={
                                        (value) => {
                                            updateSettings({
                                                ...allData,
                                                stripe_secret_key: value
                                            })
                                        }
                                    }
                                />
                            </div>
                    </PanelRow>

                    {/* <PanelRow>
                        <label>{ __( 'Enable 3d Secure', 'wp-travel-pro' ) }</label>
                        <div className="wp-travel-field-value">
                            <ToggleControl
                                checked={ stripe_enable_3d_secure == 'yes' }
                                onChange={ () => {
                                    updateSettings({
                                        ...allData,
                                        stripe_enable_3d_secure: 'yes' == stripe_enable_3d_secure ? 'no': 'yes'
                                    })
                                } }
                            />
                            <p className="description">{__( 'Check to enable 3d secure card authentication', 'wp-travel-pro' )}</p>
                        </div>
                    </PanelRow> */}
                </>
            }
        </>
    )
}